export const Work = [
  {
    id: 1,
    name: 'NeuraC',
    description:
      'MachineLearning and DeepLearning framework written in C, with inbuilt visualiser.',
    tags: ['C', 'Raylib', 'DeepLearning', 'Low Level Programming'],
    demo: 'https://keshavwrites.netlify.app/',
    github: 'https://github.com/MasterK0927/neuraC',
  },
  {
    id: 2,
    name: 'GITA GPT',
    description:
      'An AI chatbot using Three.js and a text-to-speech API, incorporating a fine-tuned 7 billion parameter Llama 2 model trained on the Bhagavad Gita dataset.',
    tags: ['Llama 2', 'AWS SageMaker', 'API', 'Three.js', 'Express.js'],
    demo: 'https://keshavwrites.netlify.app/',
    github: 'https://github.com/MasterK0927/gitaGpt',
  },
  {
    id: 3,
    name: 'Keshav Writes',
    description:
      'A full-featured blog website built using NextJs and Node.js, with capabilities for creating, editing, and deleting blog posts. Allowing users to perform CRUD operations',
    tags: ['React', 'Node.js', 'Express', 'MongoDB', 'CSS', 'Redux'],
    demo: 'https://keshavwrites.netlify.app/',
    github: 'https://github.com/MasterK0927/blogWebsite',
  },
  {
    id: 4,
    name: 'animAR_AR',
    description:
      'An augmented reality application that enhances the animation of 3D models using advanced AR technology.',
    tags: ['Augmented Reality', 'AR.js', 'Three.js', 'JavaScript'],
    demo: 'https://keshavwrites.netlify.app/',
    github: 'https://github.com/MasterK0927/animAR_AR',
  },

  {
    id: 5,
    name: 'DocSigner',
    description:
      'A PDF signing extension utilizing cryptography with an HSM (Hardware Security Module). Written natively in JavaScript for browser environment',
    tags: ['JavaScript', 'Node.js', 'Crypto', 'PDF', 'node-forge'],
    demo: 'https://keshavwrites.netlify.app/',
    github: 'https://github.com/MasterK0927/docSigner',
  },
  {
    id: 6,
    name: 'animAR',
    description:
      'An augmented reality app that allows users to animate 3D models in real-time using AR technology.',
    tags: ['Augmented Reality', 'AR.js', 'Three.js', 'JavaScript'],
    demo: 'https://keshavwrites.netlify.app/',
    github: 'https://github.com/MasterK0927/animAR',
  },
  {
    id: 7,
    name: 'World Inside Guitar',
    description:
      'An WebGL and ThreeJS based reality world inside a guitar model, showcasing projects and details in separate virtual rooms.',
    tags: [
      'Augmented Reality',
      'Spatial AR',
      '3D Modeling',
      'ThreeJS',
      'Blender',
      'WebGL',
    ],
    demo: '',
    github: 'https://github.com/MasterK0927/World_Inside_Guitar',
  },
  {
    id: 8,
    name: 'Windows File Encryptor',
    description:
      'A Windows Shell Script for encrypting and decrypting files using masking encryption standards and intruder photo capturing system.',
    tags: ['C++', 'Shell', 'Windows Forms', 'Encryption', 'Security'],
    demo: '',
    github: 'https://github.com/MasterK0927/Windows_File_Encryptor',
  },
  {
    id: 9,
    name: 'm3u8 Video Downloader',
    description:
      'A tool for downloading videos from m3u8 playlists or HLS video streams, supporting multi-threading and high-speed downloads.',
    tags: ['Python', 'Video Processing', 'Multithreading', 'ffmpeg'],
    demo: '',
    github: 'https://github.com/MasterK0927/m3u8_video_downloader',
  },
  {
    id: 10,
    name: 'LLM Based Translator',
    description:
      'A language model based translator that uses large language models to translate text between multiple languages.',
    tags: [
      'Python',
      'Natural Language Processing',
      'Machine Learning',
      'Transformers',
    ],
    demo: '',
    github: 'https://github.com/MasterK0927/LLMBasedTranslator',
  },
];
